import React from 'react';
import PropTypes from 'prop-types';
import { Col, ControlLabel, Row } from 'react-bootstrap';

/**
 * Renders a property Key/Value pair within a config `Panel`.
 */
class Property extends React.Component {
	render() {
		const { children } = this.props;
		if (!children || !children.length) {
			return null;
		}

		return (
			<Row>
				{children}
			</Row>
		);
	}
}

class PropertyName extends React.Component {
	render() {
		const { children: label } = this.props;
		return (
			<Col componentClass={ControlLabel} sm={4}>{label}:</Col>
		);
	}
}

class PropertyValue extends React.Component {
	render() {
		const { children: value } = this.props;
		return (
			<Col sm={8}>
				{value}
			</Col>
		);
	}
}

Property.propTypes = {
	/**
	 * FIXME: use shapeOf and instanceOf?
	 */
	children: PropTypes.node
};

PropertyValue.propTypes = {
	/**
	 * The property value.
	 */
	value: PropTypes.any
};

PropertyName.propTypes = {
	/**
	 * The property name.
	 */
	children: PropTypes.string.isRequired
};

Property.Name = PropertyName;
Property.Value = PropertyValue;

export default Property;
